export default {
    minimumLengthOfSearch: 3,
    defaultPageSize: 30,
}

// Fixes beszerzés
// Bizományi beszerzés
// Visszavásárlás
// Bizományos visszáru
// Botli visszáru
export const UnknownStoreOrderOperationPresets = ["SupplyPurchase", "ConsignmentReceipt", "Repurchase", "ReturnGoods", "ShopReturnGoods"];
// Szállítás vagy tranzakció
// Bevételezés alatt és mi vagyunk a customer vagy consignee
// Pos